export const headers = { 'Authorization': `Bearer ${process.env.REACT_APP_strapiToken}` };
export const openLogin = () => {
    const redirectUrl =
      process.env.REACT_APP_IDENTITY_SERVER_URL +
      "?callback_url=" +
      process.env.REACT_APP_CALLBACK_URL +
      "&client_id=" +
      process.env.REACT_APP_CLIENT_ID;

    window.location.href = redirectUrl;
  };